import { Document } from './document';

export class DocumentWithReviewInfo {
  documentName: string;
  documentPath: string;
  documentPathName?: string;
  workflowApplicationDocumentId?: string;
  isReviewed?: boolean;
  reviewedBy?: string;
  reviewedOn?: string;
  reviewedOnString?: string;
  uploadedOn?: string;
  uploadedOnString?: string;
  uploadedBy?: string;
  createdOn?: string;
  createdOnString?: string;
  createdBy?: string;
  modifiedOn?: string;
  modifiedOnString?: string;
  modifiedBy?: string;

  constructor(options?: Partial<DocumentWithReviewInfo>) {
    if (options) {
      Object.assign(this, options);
    }
  }
}

export enum ActivityStatus {
  NotStarted = 0,
  InProgress = 1,
  Completed = 2,
  Canceled = 3
}

export class RequiredDocumentDataEntityInfo {
  activityId: string;
  activityDataId?: string;
  activityName: string;
  templateCode: string;
  label: string;
  isRequired: boolean;
  requireReview: boolean;
  documents: Document[];
  documentCount: number;
  activityStatus: ActivityStatus;
  validDocumentTypes?: string;
  workflowApplicationDocumentId?: string;
  documentName:string
  /** False when the current user cannot upload/modify documents for this entity
   *  (e.g. applicant activity locked after a staff activity has been reached,
   *  or the activity belongs to a role the current user cannot edit). */
  canUpload: boolean;

  constructor(options?: Partial<RequiredDocumentDataEntityInfo>) {
    if (options) {
      Object.assign(this, options);
      if (options.documents) {
        this.documents = options.documents.map(d => new Document(d));
      }
    }
  }
}

export class RequiredDocumentDataEntitiesResponse {
  documentEntities: RequiredDocumentDataEntityInfo[];
  applicationNumber: string;
  applicationId: string;

  constructor(options?: Partial<RequiredDocumentDataEntitiesResponse>) {
    if (options) {
      Object.assign(this, options);
      if (options.documentEntities) {
        this.documentEntities = options.documentEntities.map(de => new RequiredDocumentDataEntityInfo(de));
      }
    }
  }
}

export class SaveDocumentDataEntityRequest {
  applicationId: string;
  activityId: string;
  activityDataId: string;
  templateCode: string;
  documents: DocumentWithReviewInfo[];

  constructor(options?: Partial<SaveDocumentDataEntityRequest>) {
    if (options) {
      Object.assign(this, options);
    }
  }
}

export class SaveDocumentDataEntitiesRequest {
  applicationId: string;
  documentDataEntities: SaveDocumentDataEntityRequest[];

  constructor(options?: Partial<SaveDocumentDataEntitiesRequest>) {
    if (options) {
      Object.assign(this, options);
      if (options.documentDataEntities) {
        this.documentDataEntities = options.documentDataEntities.map(de => new SaveDocumentDataEntityRequest(de));
      }
    }
  }
}

export class SaveDocumentDataEntitiesResponse {
  success: boolean;
  message: string;
  processedActivities: string[];

  constructor(options?: Partial<SaveDocumentDataEntitiesResponse>) {
    if (options) {
      Object.assign(this, options);
    }
  }
}
